import { useEffect } from "react";

/**
 * BreadcrumbList JSON-LD injector. Improves SERP rendering (breadcrumb rich
 * result) and gives search engines a stronger site-hierarchy signal.
 *
 * Usage:
 *   <BreadcrumbSchema items={[
 *     { name: "Home", url: "https://viewluxcolorado.com/" },
 *     { name: "Custom Doors", url: "https://viewluxcolorado.com/doors" },
 *   ]} testId="doors" />
 */
export default function BreadcrumbSchema({ items = [], testId = "page" }) {
  useEffect(() => {
    const id = `breadcrumb-jsonld-${testId}`;
    // If no items provided, ensure no stale schema is left in the head.
    if (!items || items.length === 0) {
      const stale = document.getElementById(id);
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
      return;
    }
    let el = document.getElementById(id);
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: it.url,
      })),
    };
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const cur = document.getElementById(id);
      if (cur && cur.parentNode) cur.parentNode.removeChild(cur);
    };
  }, [items, testId]);

  return null;
}
